import pic1 from '../project-image/sorting.gif'
import pic2 from '../project-image/todo.gif'
import pic3 from '../project-image/ngo.gif'
import pic4 from '../project-image/virtual.gif'
import pic5 from '../project-image/ecommerce.gif'
import pic6 from '../project-image/codeEditor.gif'
import pic7 from '../project-image/authentication.gif'
import pic8 from '../project-image/discord.gif'




export const data = [
    {
      id: 0,
      title: "Discord Clone",
      content: "Discord clone using Next js",
      image: pic8,
      tags:["Nextjs 13","prisma","postgresql"],
      link:"https://github.com/ank-2222/Discord-clone",
      github:"https://github.com/ank-2222/Discord-clone",
    },
    {
      id: 1,
      title: "Sorting Visualizer",
      content: "Different sorting technique is visualized",
      image: pic1,
      tags:["React","CSS"],
      link:"https://sortingzer.onrender.com/",
      github:"https://github.com/ank-2222/Sorting-Visualizer",
    },
    {
      id: 2,
      title: "Authentication Microservice",
      content: "Microservice for authentication using JWT Auth",
      image: pic7,
      tags:["NodeJs","Docker","PostgreSQL"],
      link:"https://github.com/ank-2222/Authentication-microservice",
      github:"https://github.com/ank-2222/Authentication-microservice",
    },
    {
      id: 3,
      title: "E-commerce Backend",
      content: "Created API's for e commerce site",
      image: pic5,
      tags:["SQL","Node js","Express js"],
      link:"https://github.com/ank-2222/ecommerce-backend",
      github:"https://github.com/ank-2222/ecommerce-backend"

    },
    
    {
      id: 4,
      title: "Code Editor Backend",
      content: "API's for authentication, problem addition, test case addition, submission using SPHERE ENGINE API",
      image: pic6,
      tags:["Node js","Rest API","MongoDB"],
      link:"https://github.com/ank-2222/onlineCode-Editor--backend",
      github:"https://github.com/ank-2222/onlineCode-Editor--backend",

    },
    {
      id: 5,
      title: "Task management App",
      content: "Manage daily basis task or can be used for project management.",
      image: pic2,
      tags:["React","npm","Firebase","MERN"],
      link:"https://github.com/ank-2222/Task-management-webapp",
      github:"https://github.com/ank-2222/Task-management-webapp",

    },
   
    {
      id: 6,
      title: "LabLink",
      content: "QR Based Quality Control system",
      image: pic3,
        tags:["React","Firebase"],
      link:"https://lab-link.onrender.com/",
      github:"https://github.com/ank-2222/lab-link",

    },
    {
      id: 7,
      title: "Todo",
      content: "Add todo list.",
      image: pic4,
        tags:["React","Redux"],
      link:"https://todo-kxl2.onrender.com",
      github:"https://github.com/ank-2222/redux_todo",

    },
   
    ]
